import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { SwapStatusScreen } from "./SwapStatusScreen.js";
import { TransferConfirmationScreen } from "./TransferConfirmationScreen.js";
export function TransferFlow(props) {
    const [transferTxHash, setTransferTxHash] = useState();
    if (transferTxHash) {
        return (_jsx(SwapStatusScreen, { title: props.title, onBack: props.onBack, onTryAgain: props.onTryAgain, swapTxHash: transferTxHash, client: props.client, onDone: props.onDone, transactionMode: false, isEmbed: props.isEmbed, quote: undefined, onSuccess: props.onSuccess }));
    }
    return (_jsx(TransferConfirmationScreen, { ...props, setTransactionHash: setTransferTxHash }));
}
//# sourceMappingURL=TransferFlow.js.map